module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("It’s around eleven when Michael arrives at the office to find that his receptionist, accountant, purchasing agent, and secretary, Rosalina Guerrero, is, as usual, at her desk, working.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Michael’s office is in a low-set building on a shady side street near a church. He shares the building complex, more like a series of converted trailers than anything else, with a landscape architect and a man who tutors high school students on college aptitude tests. Both the architect and the tutor seem to consider both a contractor and each other beneath them and so all seldom speak to one another.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rosalina, called Rose, is a dark-skinned, amber-eyed, overweight woman in her mid-thirties who will suffer fools but always makes sure they know she disapproves of them. Rose, who has never married, and much to the alarm of her Mexican mother, whom she lives with and cares for, has no children, can be sarcastic in both Spanish and English, is effortlessly organized and coldly efficient, and Michael, who is neither, would be lost without her. Beyond that, she has forgone paychecks without telling him on more than one occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Morning, Rose.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rose doesn’t so much as glance up from her computer screen. “It’s after ten, Michael, it’s no longer morning. I’m already on chapter four.” When not working on her computer, Rose reads. Thick, serious-looking books are almost always on the desk alongside her time sheets and she averages one every two days. Michael lightly waves the check in front of her. She looks at it, then takes it. She studies it a moment and, deciding not to be unimpressed, raises a heavy, unplucked eyebrow. “And this is?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Back payment plus an advance.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Do I want to know how you pried it loose?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No, you don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll take it down to the bank and deposit it before that "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("poca cagada")]), _vm._v(" changes his mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Poca cagada?”")]), _vm._v(" asks Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Little turd.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Michael smiles. “I learn something from you every day, Rose.” It’s a statement of fact as well as a compliment and Rose nods, accepting it as both. Michael turns toward his adjacent office. The door is open. His desk is not nearly so well ordered as Rose’s.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, Michael, a doctor—” Rose checks the message pad up on her desk. She hesitates, wanting to get the pronunciation right. “Akrepede’s office called. She reminds you to stop in around noon today for your…” Rose looks up at him, her tawny eyes curious. “Annual"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Michael tries to hide his surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nothing wrong, is there?” asks Rose. Just a bit too casual.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No, not at all,” says Michael. “Just a checkup.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Good. You need one,” says Rose, her curiosity and her computer with its resources and search engine ever present. “She’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("una")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("loquera")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“A shrink.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 84
// module chunks = 0